<template>
  <BaseTextViewer :text="editedArticle.description || ''" @click:close="$emit('click:close')" />
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BaseTextViewer from '../../components/base/BaseTextViewer';

export default {
  name: 'ViewArticleText',

  components: { BaseTextViewer },

  computed: mapState('articles', ['editedArticle']),

  created() {
    this.editArticle(+this.$route.params.id);
  },

  methods: mapActions('articles', ['editArticle']),
};
</script>

<style scoped></style>
